import { i18n } from 'next-i18next'
import { either, join, pipe, propEq, replace, toLower } from 'ramda'

import ENV_VARS from '@/config'

const BUILDING_TYPE = {
  condo: 'apartment',
  highrise: 'apartment',
  lowrise: 'apartment',
  house: 'house',
  townhouse: 'townhouse'
}

export const getUrl = (listing = {}) =>
  join('/', [
    '/rental-listings/detail',
    BUILDING_TYPE[listing.building_type] || 'apartment',
    pipe(toLower, replace(' ', '-'), replace('_', '-'))(listing.city || ''),
    listing?.listing_id || listing?.ids?.listing_id
  ])

const W1_IDS = {
  dev: ['1622'],
  prod: ['6505', '6506', '6509']
}

export const getPaymentFrequency = key => {
  const PAYMENT_FREQUENCY = {
    daily: i18n.t('b.listing.view.price_frequency_daily.text', 'day'),
    weekly: i18n.t('b.listing.view.price_frequency_weekly.text', 'week'),
    monthly: i18n.t('b.listing.view.price_frequency_monthly.text', 'month'),
    one_time: i18n.t(
      'b.listing.view.price_frequency_one_time.text',
      'single payment'
    )
  }
  return PAYMENT_FREQUENCY[key]
}
export const getPaymentFrequencyShort = key => {
  const PAYMENT_FREQUENCY_SHORT = {
    daily: i18n.t('b.listing.view.price_frequency_daily_short.text', 'day'),
    weekly: i18n.t('b.listing.view.price_frequency_weekly_short.text', 'wk.'),
    monthly: i18n.t(
      'b.listing.view.price_frequency_monthly_short.text',
      'mon.'
    ),
    one_time: i18n.t(
      'b.listing.view.price_frequency_one_time_short.text',
      'once'
    )
  }
  return PAYMENT_FREQUENCY_SHORT[key]
}

export const isGroup = either(propEq('gr_unit', true), propEq('gr_unit', '1'))
export const isW1 = buildingId =>
  W1_IDS[ENV_VARS.BUILD_ENV].indexOf(buildingId) >= 0

export const formatPrice = price => {
  const n = parseFloat(price).toFixed(0)
  return `$${Number(n).toLocaleString('en')}`
}
